import React, { FC, memo } from 'react'
import { HStack } from '../index'
import { Center, Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export interface PhoneAllCardProps {
  phones: string
  onClick: (phones: string) => void
}

export const PhoneAllCard: FC<PhoneAllCardProps> = memo(({ phones, onClick }) => {
  const { t } = useTranslation()

  return (
    <HStack
      role="button"
      aria-label="phone-all-card"
      width="full"
      maxWidth={290}
      maxHeight={120}
      borderRadius="default"
      justifyContent="space-between"
      padding={4}
      marginBottom={4}
      border={2}
      borderStyle="solid"
      borderColor="grey"
      userSelect="none"
      cursor="pointer"
      marginX={1}
      _hover={{
        borderColor: 'brand',
      }}
      label="phone-all-card"
      onClick={() => onClick(phones)}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          onClick(phones)
        }
      }}
      position="relative"
      _focus={{
        borderColor: 'brand',
        boxShadow: '0 0 0 3px #5bce4c',
      }}
      tabIndex={0}
      backgroundColor={'green.500'}
    >
      <Flex alignItems="center" width="full" height="100%">
        <Center width={20} height={20} flex={2} color="white" fontWeight="bold" fontSize={18} textAlign={'center'}>
          {t('search-all-phones')}
          {/* <FluidImage src={`https://www.planhub.ca/img/phone/${phone.slug}.png`} alt='' /> */}
        </Center>
      </Flex>
    </HStack>
  )
})
